import React, { useEffect, useState } from "react";

const Language = () => {
  const languages = [
    "English",
    "Mandarin Chinese",
    "Hindi",
    "Spanish",
    "French",
    "Arabic",
    "Bengali",
    "Portuguese",
    "Russian",
    "Urdu"
  ];

  const [selectedLanguage, setSelectedLanguage] = useState("English");

  useEffect(() => {
    const savedLanguage = localStorage.getItem("onnize_language");
    if (savedLanguage) {
      setSelectedLanguage(savedLanguage);
    }
  }, []);

  const handleChange = (language) => {
    setSelectedLanguage(language);
    localStorage.setItem("onnize_language", language);

    // Future integration point:
    // i18n.changeLanguage(languageCode);
    // dispatch(updateUserLanguage(language));
  };

  return (
    <div className="page-body page-content" style={{ height:"100vh",maxWidth: "700px", margin: "40px auto" }}>
      <h1>Language Settings</h1>
      <p>Select your preferred language for the platform.</p>

      <div style={{ marginTop: "30px" }}>
        {languages.map((language, index) => (
          <div
            key={index}
            onClick={() => handleChange(language)}
            style={{
              padding: "12px 16px",
              marginBottom: "10px",
              border: selectedLanguage === language ? "2px solid #000" : "1px solid #ddd",
              borderRadius: "6px",
              cursor: "pointer",
              fontWeight: selectedLanguage === language ? "600" : "400"
            }}
          >
            {language}
          </div>
        ))}
      </div>

      <div style={{ marginTop: "30px" }}>
        <strong>Current Language:</strong> {selectedLanguage}
      </div>
    </div>
  );
};

export default Language;
